import Cookies from 'universal-cookie'

import { app } from '../configuration'

const CONSTANTS = {
  FAM_UNLOGGED_USER: app.COOKIE_NAME + '_fam_unlogged_user',
  FAM_USER: app.COOKIE_NAME + '_fam_user',
}

export const getCookiesObj = (req: any = null) => {
  if (req?.universalCookies) {
    return req.universalCookies
  }

  return new Cookies()
}

export const getUnloggedUserCookie = (req = null) => {
  const cookies = getCookiesObj(req)
  return cookies.get(CONSTANTS.FAM_UNLOGGED_USER)
}

export const setUnloggedUserCookie = (value: any, req = null) => {
  const cookies = getCookiesObj(req)

  const initial = cookies?.get(CONSTANTS.FAM_UNLOGGED_USER, value) ?? {}
  cookies.set(
    CONSTANTS.FAM_UNLOGGED_USER,
    { ...initial, ...value },
    {
      domain: app.COOKIE_DOMAIN,
      secure: app.SECURE_COOKIE,
      path: '/',
      expires: new Date(new Date().getTime() + 60 * 60 * 24 * 1000 * 30), // 30 days
    }
  )
}

export const setAuthCookie = (value: any, req = null) => {
  const cookies = getCookiesObj(req)

  cookies.set(CONSTANTS.FAM_USER, value, {
    domain: app.COOKIE_DOMAIN,
    secure: app.SECURE_COOKIE,
    path: '/',
    expires: new Date(new Date().getTime() + 60 * 60 * 24 * 1000 * 30), // 30 days
  })
}

export const getAuthCookie = (req = null) => {
  const cookies = getCookiesObj(req)
  return cookies.get(CONSTANTS.FAM_USER)
}

export const removeAuthCookie = (req = null) => {
  const cookies = getCookiesObj(req)

  cookies.remove(CONSTANTS.FAM_USER, {
    domain: app.COOKIE_DOMAIN,
    secure: app.SECURE_COOKIE,
    path: '/',
    expires: new Date(new Date().getTime() + 60 * 60 * 24 * 1000 * 30), // 30 days
  })
}
